import type { ReactNode } from "react";
import { Plus } from "lucide-react";
import { Button, Card, FilterAddMenu, FilterRow, Pagination, type OptionalFiltersState, type PaginationProps } from "@marekl/adminer/components";

export interface ListCardProps {
  /** "Seznam vydaných faktur" — the legacy list heading. */
  title: string;
  /** The red "+ nová" pill; omitted when the user may not create. */
  onCreate?: () => void;
  /** "nová" (faktura, společnost) by default; "nový" for a masculine noun (kontakt, produkt). */
  createLabel?: string;
  /** What `useOptionalFilters` returned for the page's filters. */
  filters?: OptionalFiltersState;
  pagination?: PaginationProps;
  summary?: string;
  children: ReactNode;
}

/**
 * A list as the legacy app drew it (legacy/app/src/ui/list/ListView.tsx): one
 * card, its title with "+ nová" and "filtry" on the right, the filter row
 * always open under it — the always-on filters plus any the user added, each
 * added one removable — then the table and the paging.
 */
export function ListCard({ title, onCreate, createLabel = "nová", filters, pagination, summary, children }: ListCardProps) {
  return (
    <Card>
      <Card.Header
        title={title}
        actions={
          <>
            {onCreate && (
              <Button size="sm" variant="primary" startIcon={<Plus size={14} aria-hidden="true" />} onClick={onCreate}>
                {createLabel}
              </Button>
            )}
            {filters && <FilterAddMenu state={filters} size="sm" />}
          </>
        }
      />
      {filters && filters.shown.length > 0 && (
        <Card.Toolbar>
          <FilterRow filters={filters} />
        </Card.Toolbar>
      )}
      <Card.Content padding="none">{children}</Card.Content>
      {pagination && (
        <Card.Footer>
          <Pagination {...pagination} summary={summary} />
        </Card.Footer>
      )}
    </Card>
  );
}
